import defaultTheme from "@/utils/styles/themes/defaultTheme";
import dasaTheme from "@/utils/styles/themes/dasaTheme";
import liveloTheme from "@/utils/styles/themes/livelo";
import cnpTheme from "@/utils/styles/themes/cnpTheme";
import comGasTheme from "@/utils/styles/themes/comgasTheme";
import bancoMercantilTheme from "@/utils/styles/themes/bancoMercantilTheme.js";
import senaiTheme from "@/utils/styles/themes/senaiTheme.js";
import sesiTheme from "@/utils/styles/themes/sesiTheme";
import rexonTheme from "@/utils/styles/themes/rexonTheme";

export default class ThemeApp {
  setThemeById(id) {
    switch (id) {
      case 14:
        dasaTheme();
        break
      case 16:
        liveloTheme();
        break
      case 18:
        cnpTheme();
        break
      case 19:
        comGasTheme();
        break
      case 21:
        bancoMercantilTheme();
        break
      case 22:
        senaiTheme();
        break ;
        case 23:
         sesiTheme();
        break  ;
        case 24:
         rexonTheme();
        break
      default:
        defaultTheme();
        break;
    }
  }
}
